import {useDispatch} from "react-redux";
import ModalBody from "../../../core/Modal/ModalBody/ModalBody";
import ModalHeader from "../../../core/Modal/ModalHeader/ModalHeader";
import RakeRace from "../RakeRace/RakeRace.jsx";
import {closeLobbyModal} from "../../../redux/actions/lobby/actions.js";


function RakeRaceModal() {
    const dispatch = useDispatch();
    return <>
        <ModalHeader>
            <div className="settings-modal-header">
                <i className="icon-close" onClick={()=> dispatch(closeLobbyModal())}/>
            </div>
        </ModalHeader>
        <ModalBody>
            <RakeRace/>
        </ModalBody>
    </>
}

export default RakeRaceModal